import { Network, Alchemy } from 'alchemy-sdk';
import { ethers } from 'ethers';
const settings = {
    //      apiKey: '5f7tMbLfXX_-qeD6SWj1lkYm59Ti6psk', // Eth key.
    //      network: Network.MATIC_MUMBAI // Eth network.
              apiKey: '94VKsRUJhZJviWy-0DP_4pPqxSeDSGiB', // Matic key.
          network: Network.MATIC_MAINNET // Matic network.
        };
      const alchemy = new Alchemy(settings);
      //Elegant Ocean racers Contract Live
      const contractadd = '0x72106Bbe2b447ECB9b52370Ddc63cfa8e553B08C';
      //Pearl Contract Live
      const pearlcontractadd = '0xCAf44e62003De4B8bD17c724f2B78CC532550C2F';
      //Account Contract Live
      const accountcontractadd = '0x0f27Ea0892fdcD8aDE0aDF2F42c64d8d43b75081';//'0x3dC7162f1D359Ec10D447C900308a000108Aa14b';//'0xA22444267c3e9B4513cA1576F7baF5a1ABF2eeFb';
      //EOR Custom Contract Live
      const customcontractadd = '0xabA082D325AdC08F9a1c5A8208Bb5c42B3A6F978';
      //EOR Staking Contract Live
      const stakingcontractadd = '0x65E1d283A8BD74BFb13eA53985d0A069A0005E3A';//'0xEb2B3325822761252255ec1E49f0686B9Ba1e164';//'0x7e2dd105B1B9A51b439969948f698528658aB4A5';//'0x038e91B03c7bDD503bbD42FA6C9813Ca5621D728'//'0xC999bA0860Fb4B4372116cFa413376de2590BE14';//'0xdB925381163CBf1Ed8463d53777C804fB2ce0ea0';//'0x9f4baf4b961Bc37aED287CBeC7951a4C36793a8a';//'0x2B8758dC1618e8A9296b4b57c2A47b67e53CBFc5';
      //EOR Staking Contract Roles and Hydrolyte
      const stakingcontracttwoadd = '0xCbaDdd5D228fE692a9B38F352B51Dd903c550B3D';
      //EOR Mint Proxy Live
      const mintproxyadd = '0x0fF6ffEF2f6A1E9D2d400E4387a677BCc01f0EC6';//'0x5e3E1A926e0DFad40a4be4939C77e9487d2De02C';//'0xef32fFACc5c74044E5cA6918742193d9B18a48DF';//'0x63D987018Ea1A9F55C4b637638a1c7aA9655A629';
      //Coach contract Live
      const coachcontract = '0x28dB8c7721b5765a0CD5617f9f85733115164C3e';//'0x71Ef0488d78ed490C8fFA3112Fb3D7B4614F76b5';

      const toscontractadd = '0xA06315F6AbEb695918Cdcb059be251A5Bb76F79c';

            //Elegant Ocean racers Contract mumbai
    //        const contractadd = '0x6De8482cA107bc87AA23208fEE28C5b160FD3E6c';
            //Pearl Contract mumbai
    //        const pearlcontractadd = '0x3B782594595096f1c854A606945980834b8a0e0c';
            //Account Contract mumbai
    //        const accountcontractadd = '0x4d506fEDAfDF7aAef2e1E24960b929040F02568d';
            //EOR Custom Contract mumbai
    //        const customcontractadd = '0x6Dc9207608Ac27Eb68B7E76B39C193F98284D9a7';
            //Elegant Street Racing Contract mumbai
    
      const pearlabi = require('../json/pearlabi.json');
      const eorabi = require('../json/eorabi.json');
      const accountabi = require('../json/accountabi.json');
      const getcollectionabi  = require('../json/collections.json');
      const stakingabi = require('../json/staking.json');
      const stakingtwoabi = require ('../json/stakingtwo.json');
      const proxyabi = require('../json/mintproxy.json');
      const coachabi = require('../json/coachabi.json');
      const tosABI = require('../json/eleganttos.json');
      const roprovider = alchemy.config.getProvider();
      

      const getPearlContractRO = () => {
      
             const getProv = async() => {
                 const prov = await roprovider;
                 const pearlcontract = new ethers.Contract(pearlcontractadd, pearlabi, prov);
                 
                 return pearlcontract;
             }
            
              return getProv();
         
       }

       const getEORContractRO = () => {
      
        const getProv = async() => {
            const prov = await roprovider;
            const eorcontract = new ethers.Contract(contractadd, eorabi, prov);
            
            return eorcontract;
        }
       
         return getProv();
    
  }

  const getEORContractForCalls = () => {
      
    const getProv = async() => {
     const prov = new ethers.BrowserProvider(window.ethereum);
        await prov.send("eth_requestAccounts", []);
        const signer = await prov.getSigner();
        const contract = new ethers.Contract(contractadd, eorabi, signer);
        
        return contract;
    }
  
    return getProv();
  
  }

  const getCoachContractRO = () => {
      
    const getProv = async() => {
        const prov = await roprovider;
        const coachcon = new ethers.Contract(coachcontract, coachabi, prov);
        
        return coachcon;
    }
   
     return getProv();

}

const getCoachContractForCalls = () => {
      
  const getProv = async() => {
   const prov = new ethers.BrowserProvider(window.ethereum);
      await prov.send("eth_requestAccounts", []);
      const signer = await prov.getSigner();
      const contract = new ethers.Contract(coachcontract, coachabi, signer);
      
      return contract;
  }

  return getProv();

}

  const getNFTContractRO = (nftaddress)=>{
    const getProv = async() => {
      const prov = await roprovider;
      const nftcontract = new ethers.Contract(nftaddress, eorabi, prov);
      
      return nftcontract;
  }
 
   return getProv();
  }

  const getAccountContractRO = () => {
      
    const getProv = async() => {
        const prov = await roprovider;
        const acccontract = new ethers.Contract(accountcontractadd, accountabi, prov);
        
        return acccontract;
    }
   
     return getProv();

}

const getProxyContractRO = () => {
  const getProv = async() => {
    const prov = await roprovider;
    const acccontract = new ethers.Contract(mintproxyadd, proxyabi, prov);
    
    return acccontract;
}

 return getProv();
}

const getProxyContractForCalls = () => {
      
  const getProv = async() => {
   const prov = new ethers.BrowserProvider(window.ethereum);
      await prov.send("eth_requestAccounts", []);
      const signer = await prov.getSigner();
      const contract = new ethers.Contract(mintproxyadd, proxyabi, signer);
      
      return contract;
  }

  return getProv();

}

const getAccContractForCalls = () => {
      
  const getProv = async() => {
   const prov = new ethers.BrowserProvider(window.ethereum);
      await prov.send("eth_requestAccounts", []);
      const signer = await prov.getSigner();
      const contract = new ethers.Contract(accountcontractadd, accountabi, signer);
      
      return contract;
  }

  return getProv();

}

  const getStakingContractRO = () => {
      
    const getProv = async() => {
        const prov = await roprovider;
        const stakingcontract = new ethers.Contract(stakingcontractadd, stakingabi, prov);
        
        return stakingcontract;
    }
   
     return getProv();

}

const getStakingContractForCalls = () => {
      
  const getProv = async() => {
   const prov = new ethers.BrowserProvider(window.ethereum);
      await prov.send("eth_requestAccounts", []);
      const signer = await prov.getSigner();
      console.log(signer);
      const contract = new ethers.Contract(stakingcontractadd, stakingabi, signer);
      
      return contract;
  }

  
   return getProv();

}

const getStakingContractOtherRO = () => {
      
    const getProv = async() => {
        const prov = await roprovider;
        const stakingcontract = new ethers.Contract(stakingcontracttwoadd, stakingtwoabi, prov);
        
        return stakingcontract;
    }
   
     return getProv();

}

const getStakingContractOtherForCalls = () => {
      
  const getProv = async() => {
   const prov = new ethers.BrowserProvider(window.ethereum);
      await prov.send("eth_requestAccounts", []);
      const signer = await prov.getSigner();
      console.log(signer);
      const contract = new ethers.Contract(stakingcontracttwoadd, stakingtwoabi, signer);
      
      return contract;
  }

  
   return getProv();

}

const getCustomContractRO = () => {
      
  const getProv = async() => {
      const prov = await roprovider;
      const eorcontract = new ethers.Contract(customcontractadd, eorabi, prov);
      
      return eorcontract;
  }
 
   return getProv();

}



const getNFTCollectionRO = (collectionaddress) => {

  const getProv = async(collectionaddress) => {
    const prov = await roprovider;
    let abi = {};
    const collection = getCollectionByAddress(collectionaddress);
      if (collection === undefined){
        return "Error";
      }

    abi = eval(collection.abivar);

    const contract = new ethers.Contract(collectionaddress,abi,prov)
    return contract;
  }

  return getProv(collectionaddress);
}


  const getPRContractForCalls = () => {
      
    const getProv = async() => {
     const prov = new ethers.BrowserProvider(window.ethereum);
        await prov.send("eth_requestAccounts", []);
        const signer = await prov.getSigner();
        const contract = new ethers.Contract(pearlcontractadd, pearlabi, signer);
        
        return contract;
    }
     
   
  

     return getProv();

}

  const getReadOnlyProvider = async () => {

    return roprovider;
      
   }

   const getNFTCollectionforCalls = (collectionaddress) => {

    const getProv = async(collectionaddress) => {
      const prov = new ethers.BrowserProvider(window.ethereum);
      let abi = {};
      const collection = getCollectionByAddress(collectionaddress);
      if (collection === undefined){
        return "Error";
      }
          abi = eval(collection.abivar);
        
      await prov.send("eth_requestAccounts", []);
        const signer = prov.getSigner();
      const contract = new ethers.Contract(collectionaddress,abi,signer)
      return contract;
    }
  
    return getProv(collectionaddress);
  }

  const getTOSContractRO = () => {
      
    const getProv = async() => {
        const prov = await roprovider;
        const eorcontract = new ethers.Contract(toscontractadd, tosABI, prov);
        
        return eorcontract;
    }
   
     return getProv();

}

const getTOSContractForCalls = () => {
  
const getProv = async() => {
 const prov = new ethers.BrowserProvider(window.ethereum);
    await prov.send("eth_requestAccounts", []);
    const signer = await prov.getSigner();
    const contract = new ethers.Contract(toscontractadd, tosABI, signer);
    
    return contract;
}

return getProv();

}



  const getCollectionByAddress = (collectionaddress) => {
    let collection = {};
    for (let i = 0; i < getcollectionabi.length; i++){
      if (getcollectionabi[i].address.toLowerCase() === collectionaddress.toLowerCase()){
        collection = getcollectionabi[i];
        break;
      }
    }

    return collection;
  }



      const returnAlch = () => {
        return alchemy;
      }

      const returnContract = () => {
        return contractadd;
      }

     const returnAccContract = () => {
       return accountcontractadd;
     }


    export {getPearlContractRO, getEORContractRO, returnAlch, getAccountContractRO, getCustomContractRO,  returnContract, getReadOnlyProvider, getNFTContractRO, getPRContractForCalls, getNFTCollectionRO, getNFTCollectionforCalls, getCollectionByAddress, getAccContractForCalls, contractadd, pearlcontractadd, stakingcontractadd, stakingcontracttwoadd, getStakingContractRO, getStakingContractForCalls, getStakingContractOtherRO, getStakingContractOtherForCalls, getProxyContractRO, getCoachContractRO, getProxyContractForCalls, getCoachContractForCalls,getEORContractForCalls, getTOSContractForCalls, getTOSContractRO,returnAccContract}
